import { Typography } from "@mui/material"
import Box from "@mui/material/Box"

const styles = {
  footer: {
    height: "60px",
    backgroundColor: "#CCCCCC",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingX: "80px",
  },
}

const Footer = () => {
  return (
    <Box sx={styles.footer}>
      <Typography>Pheno.AI DeepSight</Typography>
      <Typography>© 2025 Pheno.AI. All rights reserved.</Typography>
    </Box>
  )
}

export default Footer
